
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment, { Moment } from 'moment-timezone';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

library.add(faMinus, faPlus);

// I don't like this component. :)
@Component({})
export default class AppointmentsSchedule extends Vue {
	@Prop({ required: true })
	defaultSchedules!: number[][];

	@Prop({ required: true })
	defaultDurations!: number[];

	schedules: number[][] = [];
	durations: number[] = [];

	// Where durations are stored before they are confirmed.
	temporaryDurations!: number[];

	selectedNumAppointments = 0;
	painting = false;

	// This choice of date is completely arbitrary; I just needed
	// a base time of midnight off which we can add 30-minute intervals.
	base: Moment = moment.tz('2020-01-01T00:00:00', moment.tz.guess());

	constructor() {
		super();
		for (let i = 0; i < this.defaultSchedules.length; i++) {
			this.schedules.push([...this.defaultSchedules[i]]);
		}
		this.durations = [...this.defaultDurations];
		this.temporaryDurations = [...this.defaultDurations];
	}

	changeSlot(i: number, j: number) {
		Vue.set(this.schedules[i], j, this.selectedNumAppointments);
	}

	setDuration(i: number) {
		const newSchedule = new Array(
			Math.floor((60 * 24) / this.temporaryDurations[i])
		);
		newSchedule.fill(0);
		this.schedules.splice(i, 1, newSchedule);
		this.durations.splice(i, 1, this.temporaryDurations[i]);
	}

	getColorForAvailability(numAvailable: number, brightness = 1) {
		const hueStart = 120;
		const hueMax = 0;
		const hueRange = hueMax - hueStart;
		const maxAvailable = 9;
		if (numAvailable === 0) {
			return '#777';
		}

		const hue = Math.floor(
			hueStart + ((numAvailable - 1) * hueRange) / (maxAvailable - 1)
		);
		return `hsl(${hue}, 39%, ${Math.floor(54 * brightness)}%)`;
	}
}
